export default __webpack_public_path__ + "static/media/asset-icon.f7a6d55b.svg";